import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { productCode } from '../../helpers/gtin'
import { OptionSelect, SelectOptionItem } from './OptionSelect'
import { ProductThumb } from './ProductThumb'

import styles from './styles.module.css'

type UnassignedSuggestionRowProps = {
  product: AdvertiserBrandProduct
  imageUrl?: string | null
  brandOptions: SelectOptionItem[]
  value: string | null
  isSuggested: boolean
  onAssign: (brand: string | null) => void
}

/** Produto · EAN ou SKU · marca sugerida, com o select destacado quando é sugestão. */
export const UnassignedSuggestionRow: React.FC<
  UnassignedSuggestionRowProps
> = ({ product, imageUrl, brandOptions, value, isSuggested, onAssign }) => {
  const { t } = useAPPTranslation()

  return (
    <div className={styles.suggestionBodyRow}>
      <span className={styles.productCell}>
        <ProductThumb url={imageUrl} />
        <span className={styles.productText}>
          <span className={styles.productName}>
            {product.product_name ?? productCode(product)}
          </span>
        </span>
      </span>

      <span className={styles.count}>
        {product.identifier_type === 'sku' ? 'SKU' : 'EAN'}:
        {productCode(product)}
        {!!product.publisher_name && ` · ${product.publisher_name}`}
      </span>

      <span>
        <OptionSelect
          placeholder={t(
            'rm:advertiserProducts.unassignedSuggestions.brand.placeholder'
          )}
          options={brandOptions}
          value={value}
          tone={isSuggested ? 'suggested' : 'default'}
          onChange={option => onAssign(option?.value ?? null)}
        />
      </span>
    </div>
  )
}
